import styled from 'styled-components';

export const StyledImage = styled.img`
  max-width: 35.3rem;
`;
